var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DeleteButton',{attrs:{"is-loading":_vm.isLoading},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.deletionConfirm.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }